<template>
  <div v-show="showDrawer">
    <v-app-bar
      :fixed="true"
      :clipped-left="true"
      dense
      app>
      <v-app-bar-nav-icon
        @click.stop="toggleDrawer" />
      <v-toolbar-title>ФАР</v-toolbar-title>
      <v-spacer />
      <v-btn icon>
        <router-link to="/login">
          <v-icon>logout</v-icon>
        </router-link>
      </v-btn>
    </v-app-bar>
    <div class="md-12">
      <v-navigation-drawer v-model="drawer"
                           clipped
                           app
                           fixed
                           disable-route-watcher>
        <v-toolbar text class="transparent">
          <v-list class="pa-0">
            <v-list-item>
              <v-list-item-avatar>
                <img :src="avatar">
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ userName }}
                </v-list-item-title>
                <v-list-item-subtitle v-for="pos in userPosition" :key="pos">
                  {{ pos }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-toolbar>
        <v-list class="pt-0" dense>
          <v-divider />
          <template v-if="outreachRights">
            <v-list-item
              v-for="item in items"
              :key="item.title"
              :class="$route.path.indexOf(item.link) > -1 || $route.path==='/'? 'highlighted' : ''"
              :to="{ name: item.name, params: item.params }"
              @click="click(item.title)"
              active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }} </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-if="caseManagementAddRights">
            <v-list-item
              v-for="item in caseManagement"
              :key="item.title"
              :class="$route.path.indexOf(item.link) > -1 || $route.path==='/'? 'highlighted' : ''"
              :to="{ name: item.name, params: item.params }"
              @click="click(item.title)"
              active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-if="currentUser && currentUser.user_info && currentUser.user_info.type !== 'волонтер'">
            <v-list-item
              v-for="item in seminars"
              v-if="outreachRights || caseManagementAddRights || isAdmin"
              :key="item.title"
              :class="item.link === $route.path ? 'highlighted' : ''"
              :to="item.link"

              @click="click(item.title)"
              active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="item in psych"
                         v-if="psyschologyRights"
                         :key="item.title"
                         :class="$route.path.indexOf(item.link) > -1 ? 'highlighted' : ''"
                         :to="{ name: item.name, params: item.params }"
                         @click="click(item.title)"
                         active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="item in lawyers"
              v-if="lawyerRights"
              :key="item.title"
              :class="$route.path.indexOf(item.link) > -1 ? 'highlighted' : ''"
              :to="{ name: item.name, params: item.params }"
              @click="click(item.title)"
              active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="item in lgbtq"
              v-if="lgbtqRights"
              :key="item.title"
              :class="item.link === $route.path ? 'highlighted' : ''"
              :to="item.link"
              @click="click(item.title)"
              active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
              <!--              </router-link>-->
            </v-list-item>
            <v-divider />
            <v-list-item
              v-for="item in reportsList"
              :key="item.title"
              :class="item.link === $route.path ? 'highlighted' : ''"
              :to="item.link"
              @click="click(item.title)"
              active-class="highlighted">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider />

          <v-list-group
            v-if="adminRights"
            no-action
            value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Отчетность</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(report, i) in reports"
              :key="i"
              :class="report.link === $route.path ? 'highlighted' : ''"
              :to="report.link"
              @click="click(report.title)"
              style="padding-left: 40px !important;"
              active-class="highlighted">
              <v-list-item-title>
                {{ report.title }}
              </v-list-item-title>
              <v-list-item-action>
                <v-icon v-text="report.icon" />
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
          <v-divider />
          <v-list-group
            v-if="adminRights"
            no-action
            value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Администрирование</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item
              v-for="(admin, i) in admins"
              :key="i"
              :class="admin.link === $route.path ? 'highlighted' : ''"
              :to="admin.link"
              @click="click(admin.title)"
              style="padding-left: 40px !important;"
              active-class="highlighted">
              <v-list-item-title>
                {{ admin.title }}
              </v-list-item-title>
              <v-list-item-action>
                <v-icon v-text="admin.icon" />
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
          <v-list-group
            v-if="adminRights"
            no-action
            value="true">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Импорт</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item
              v-for="(admin, i) in importActions"
              :key="i"
              :class="admin.link === $route.path ? 'highlighted' : ''"
              :to="admin.link"
              @click="click(admin.title)"
              style="padding-left: 40px !important;"
              active-class="highlighted">
              <v-list-item-title>
                {{ admin.title }}
              </v-list-item-title>
              <v-list-item-action>
                <v-icon v-text="admin.icon" />
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>

export default {
  name: "Navigation",
  props: {
    user: {
      type: String,
      default: 'Пользователь'
    },
    drawerInit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      drawer: this.drawerInit,
      items: [
        {title: 'Аутрич', icon: 'mdi-needle', link: 'outreach', params:{reportId: 'new'}, name: 'ReportOutreachForm', right: 'out', cls:'outreach'}
      ],
      reportsList: [
        {title: 'Список отчетов', icon: 'mdi-playlist-edit', link: '/reports', right: 'all'},
        // {title: 'Список мероприятий', icon: 'mdi-clipboard-list', link: '/seminars_report', right: 'all'}
      ],
      caseManagement: [
        {title: 'КМ', icon: 'mdi-briefcase-plus', link: 'case',params:{reportId: 'new'}, name: 'ReportCaseForm', right: 'case'},
        {title: 'Мероприятие', icon: 'mdi-calendar-plus', link: '/seminars',name: 'ReportSeminars', right: 'case'},
      ],
      seminars: [
        // {title: 'Мероприятие', icon: 'mdi-calendar-plus', link: '/seminars',name: 'ReportSeminars', right: 'case'},
      ],
      psych: [
        {title: 'Психолог', icon: 'mdi-brain', link: 'psych', name: 'ReportPsychForm', right: 'psych',params:{reportId: 'new'}},
      ],
      lawyers: [
        {title: 'Юрист', icon: 'gavel', link: 'lawyers', name: 'ReportLawyerForm', right: 'lawyer',params:{reportId: 'new'}}
      ],
      lgbtq: [
        // {title: 'ЛГБТКИ+', icon: 'looks', link: '/lgbtq', right: 'lgbtq'}
      ],
      admins: [{'title': 'Пользователи', icon: 'people_outline', link: '/users'},
        {'title': 'Проекты',  link: '/projects'},
        {'title': 'Профили',  link: '/profiles'},
        {'title': 'Группы',  link: '/groups'},
        {'title': 'Места', link: '/places'},
        {'title': 'Материалы', link: '/products'},
        {'title': 'Консультации', link: '/consultings'},
        {'title': 'Глобальные индикаторы', link: '/globalindicators'},
        {'title': 'Типы консультаций', link: '/consultstype'},
        {'title': 'Направления', link: '/directions'},
        {'title': 'Тесты', link: '/tests'},
        {'title': 'Заболевания', link: '/diseaseTypes'},
        {'title': 'Типы продуктов', link: '/productTypes'},
        // {'title': 'Классификаторы', link: '/classificators'},
        {'title': 'Роли', link: '/roles'}
      ],
      importActions: [{'title': 'Загрузить отчеты из эксель', link: '/upload_report'}],
      reports: [
        {'title': 'Индикаторы', link: '/indicators'},
        {'title': 'Детальный отчет', link: '/person_detailed'},
        {'title': 'Работа сотрудников', link: '/users_work'},
        {'title': 'Характеристика контактов', link: '/cust_char'},
        {'title': 'Повозрастной отчет о контактах', link: '/cust_ages'},
        {'title': 'Участники', link: '/customers'},
        {'title': 'Запросы клиентов', link: '/customer_case_help'},
        {'title': 'Упоминания в медиа', link: '/media'}
      ],
      seminarReports: [{'title': 'Мероприятия отчет', link: '/seminars_report'}
      ],
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    showDrawer () {
      return this.$route.path !== "/login" && this.$route.path !== "/password_reset"
    },
    adminRights () {
      if (this.currentUser && this.currentUser.rights !== undefined) {
        return this.currentUser.user_info.type === 'админ'
      } else return false

    },
    roleType () {
      if (this.$route.path !== "/login" && this.$route.path !== "/password_reset") {
        let roles = this.currentUser.roles.map(val => val.rights )
        if (this.currentUser.user_info.type === 'админ') return 'all'
        return  roles

      }
      return ''
      // let rls = roles.length > 1 ? this.currentUser.roles.indexOf(1) > -1 ? 'out' : 'case' : 'all'
      // return rls
    },
    outreachRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && (this.roleType.indexOf('outreaches' )> -1 || this.roleType === 'all'))
        return this.currentUser.rights.reportAdd
      return false
    },
    psyschologyRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && (this.roleType.indexOf('psychologists' )> -1 || this.roleType === 'all'))
        return this.currentUser.rights.reportAdd
      return false
    },
    lawyerRights () {
      if (this.currentUser && this.currentUser.rights !== undefined &&  (this.roleType.indexOf('lawyers' )> -1 || this.roleType === 'all'))
        return this.currentUser.rights.reportAdd
      return false
    },
    seminarRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && (this.roleType.indexOf('seminars')> -1 || this.roleType === 'all'))
        return this.currentUser.rights.reportAdd
      return false
    },
    lgbtqRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && (this.roleType.indexOf('lgbtqcommunities' )> -1 || this.roleType === 'all'))
        return this.currentUser.rights.reportAdd
      return false
    },
    caseManagementAddRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && (this.roleType.indexOf('casemanagements' )> -1 || this.roleType === 'all')
          && this.currentUser.user_info.type !== 'волонтер')
        return this.currentUser.rights.reportAdd
      return false
    },
    caseManagementReadRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && (this.roleType.indexOf('casemanagements' )> -1 || this.roleType === 'all')
          && this.currentUser.user_info.type !== 'волонтер')
        return this.currentUser.rights.reportRead
      return false
    },
    reportReadRights () {
      if (this.currentUser && this.currentUser.rights !== undefined && this.currentUser.user_info.type !== 'волонтер') return this.currentUser.rights.reportRead
      return false
    },
    userName () {
      return this.currentUser && this.currentUser['user_info'] ? this.currentUser['user_info']['name'] : 'Пользователь'
    },
    avatar () {
      let avatar
      if (this.currentUser && this.currentUser['user_info']) {
        if (this.currentUser['user_info']['avatar'] && this.currentUser['user_info']['avatar'] !== '') {
          avatar = this.currentUser['user_info']['avatar']
        } else avatar = "/static/agent.jpg"
      }
      return avatar
    },
    userPosition () {
      if (this.currentUser && this.currentUser['user_info'] && this.currentUser.user_info.type === 'админ') return ['Админ']
      if (this.currentUser && this.currentUser['roles']) return this.currentUser.roles.map(val => val.name)
      // let names = this.currentUser.roles.map(val => val.name).join('/')
      return ''
      // if (this.roleType === 'all') return 'Аутрич/Кейс'
      // if (this.roleType === 'case') return 'Кейс'
      // if (this.roleType === 'out') return 'Аутрич'
      // return ''
    }

  },
  watch: {
    drawerInit (newValue) {
      this.drawer = newValue
    }

  },
  methods: {
    click (title) {
      this.$emit('change', title)
    },
    toggleDrawer () {
      this.drawer = !this.drawer
    }
  }
}
</script>

<style scoped lang="scss">
.highlighted {
  background-color: #b3d4fc;
  color: #000;
  text-shadow: none;
}

a {
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue